import React from 'react';
import { QRCode as AntQRCode } from 'antd';
import type { QRCodeProps as AntQRCodeProps } from 'antd/lib';
import styled, { css, keyframes } from 'styled-components';
import UiKit from '../../../../shared/ui/ui-kit';

interface QRCodeProps extends AntQRCodeProps {
  expiredText?: PlainText;
  refreshText?: PlainText;
  loadingText?: PlainText;
  loading?: boolean;
}

function QRCode({ expiredText, refreshText, loadingText, loading, ...rest }: QRCodeProps) {
  const customStatusRender: QRCodeProps['statusRender'] = info => {
    switch (info.status) {
      case 'expired':
        return (
          <div>
            {expiredText}
            <UiKit.Button icon={<Reload $loading={loading} />} type="link" onClick={info.onRefresh}>
              {loading && loadingText
                ? loadingText
                : refreshText
                ? refreshText
                : info.locale?.refresh}
            </UiKit.Button>
          </div>
        );
      case 'loading':
        return (
          <LoadingWrapper>
            <UiKit.Spin />
            <p>{loadingText ? loadingText : 'Loading...'}</p>
          </LoadingWrapper>
        );
      default:
        return null;
    }
  };

  return <AntQRCode {...rest} statusRender={customStatusRender} />;
}

const Reload = styled(UiKit.icons.Reload)<{ $loading?: boolean }>`
  ${({ $loading }) =>
    $loading &&
    css`
      animation: ${spin} 1s linear infinite;
    `}
`;

const spin = keyframes`
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  `;

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export { QRCode };
